import { createBrowserRouter, Navigate, redirect } from 'react-router-dom';

import DocuSignAuthenticated from 'features/elements/Authentication/DocuSignAuthenticated';
import CampaignsViewPage from 'features/elements/CampaignsView/CampaignsViewPage';
import OnboardingPage from 'features/onboarding/OnboardingPage';
import ReportingDashboardRoute from 'features/reportingDashboard/ReportingDashboardRoute';
import IntegrationsSettingsPage from 'features/settings/IntegrationsSettingsPage';
import ProfileSettingsPage from 'features/settings/ProfileSettingsPage';
import SettingsLayout from 'features/settings/SettingsLayout';
import BrandedLayout from 'layout/BrandedLayout';
import RequireAgentProfileSettingsLayout from 'layout/RequireAgentProfileSettingsLayout';
import RequireIntegrationAccessLayout from 'layout/RequireIntegrationAccessLayout';
import RPDataAuthenticated from './features/elements/Authentication/RpDataAuthenticated';
import AuthenticatedLayout from './layout/AuthenticatedLayout';
import Form from 'features/form/form';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AuthenticatedLayout />,
    children: [
      {
        path: 'onboarding',
        element: <OnboardingPage />,
      },
      {
        path: 'onboarding/rpdata/callback',
        element: <RPDataAuthenticated />,
      },
      {
        path: 'rpdata/authenticated',
        loader: ({ request }) => {
          const { search } = new URL(request.url);

          return redirect(`/onboarding/rpdata/callback${search}`);
        },
      },
      {
        path: 'onboarding/docusign/callback',
        element: <DocuSignAuthenticated />,
      },
      {
        element: <RequireIntegrationAccessLayout />,
        children: [
          {
            index: true,
            element: (
              <BrandedLayout fillViewport>
                <CampaignsViewPage />
              </BrandedLayout>
            ),
          },
          {
            path: 'form',
            element: <Form />,
          },
          {
            path: 'dashboard',
            element: (
              <BrandedLayout>
                <ReportingDashboardRoute />
              </BrandedLayout>
            ),
          },
          {
            element: (
              <BrandedLayout fillViewport>
                <RequireAgentProfileSettingsLayout />
              </BrandedLayout>
            ),
            children: [
              {
                path: 'settings',
                element: <SettingsLayout />,
                children: [
                  {
                    path: 'profile',
                    element: <ProfileSettingsPage />,
                  },
                  {
                    path: 'integrations',
                    element: <IntegrationsSettingsPage />,
                  },
                ],
              },
              {
                path: 'settings/*',
                element: <Navigate to="/settings/profile" replace />,
              },
            ],
          },
        ],
      },
    ],
  },
]);

export default router;
